// extracted by mini-css-extract-plugin
export default {"wrapper":"MultiStateSwitch_wrapper__yvyrE","switch":"MultiStateSwitch_switch__Y0tT+","disabled":"MultiStateSwitch_disabled__UIbm-"};